import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { LOGO_URL, CAREERS_EMAIL } from '../constants/assets';

const { FiPhone, FiMail, FiMapPin } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-mag-black text-white pt-20 pb-10 border-t-[12px] border-mag-green font-sans">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 mb-16">
          
          {/* Brand & Contact Column - Spans 4 cols on large screens to prevent wrapping */}
          <div className="col-span-1 md:col-span-5 lg:col-span-4">
            <div className="bg-white p-4 rounded-xl inline-block mb-8 shadow-lg">
              <img 
                src={LOGO_URL} 
                alt="MAG Insulation" 
                className="h-10 w-auto"
              />
            </div>
            
            <div className="space-y-5">
              <a href="tel:989-662-1400" className="group flex items-center space-x-3 text-3xl sm:text-4xl font-black text-mag-green hover:text-white transition-colors w-max">
                <SafeIcon icon={FiPhone} className="w-8 h-8 flex-shrink-0" />
                <span className="whitespace-nowrap">989-662-1400</span>
              </a>
              
              <a href={`mailto:${CAREERS_EMAIL}`} className="group flex items-center space-x-3 text-gray-300 hover:text-mag-green transition-colors font-bold uppercase tracking-widest text-sm sm:text-base w-max">
                <SafeIcon icon={FiMail} className="w-5 h-5 flex-shrink-0" />
                <span className="whitespace-nowrap">{CAREERS_EMAIL}</span>
              </a>
            </div>
          </div>

          {/* Locations - Spans remaining space */}
          <div className="col-span-1 md:col-span-7 lg:col-span-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-4 lg:gap-8">
              {/* Auburn */}
              <div className="space-y-4">
                <h3 className="text-mag-green font-black uppercase tracking-widest text-sm">Auburn HQ</h3>
                <div className="flex items-start space-x-3 text-gray-200">
                  <SafeIcon icon={FiMapPin} className="w-5 h-5 text-mag-blue mt-1 flex-shrink-0" />
                  <p className="font-bold leading-relaxed text-sm lg:text-base">
                    4527 S Garfield Rd,<br />
                    Auburn, MI 48611
                  </p>
                </div>
              </div>

              {/* Grand Rapids */}
              <div className="space-y-4">
                <h3 className="text-mag-green font-black uppercase tracking-widest text-sm">Grand Rapids</h3>
                <div className="flex items-start space-x-3 text-gray-200">
                  <SafeIcon icon={FiMapPin} className="w-5 h-5 text-mag-blue mt-1 flex-shrink-0" />
                  <p className="font-bold leading-relaxed text-sm lg:text-base">
                    4717 Broadmoor SE,<br />
                    Kentwood, MI 49512
                  </p>
                </div>
              </div>

              {/* Traverse City */}
              <div className="space-y-4">
                <h3 className="text-mag-green font-black uppercase tracking-widest text-sm">Traverse City</h3>
                <div className="flex items-start space-x-3 text-gray-200">
                  <SafeIcon icon={FiMapPin} className="w-5 h-5 text-mag-blue mt-1 flex-shrink-0" />
                  <p className="font-bold leading-relaxed text-sm lg:text-base">
                    6565 E. Railway Commons,<br />
                    Williamsburg, MI 49690
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-500 font-bold uppercase tracking-widest text-xs gap-4 text-center md:text-left">
          <p>&copy; {new Date().getFullYear()} MAG Insulation. All Rights Reserved.</p>
          <div className="flex flex-wrap justify-center gap-6 md:gap-8">
            <a href="https://maginsulation.com" target="_blank" rel="noopener noreferrer" className="hover:text-mag-green transition-colors">Main Website</a>
            <span className="hidden md:inline text-white/20">|</span>
            <span className="text-mag-blue">Careers Portal</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;